module.exports = "/images/london-27.jpg";